module.exports = __webpack_public_path__ + "img/Group 4310.bf4dae01.png";